import PageHeader from '../../components/PageHeader/PageHeader';
import "../Style/style.css";
import { Row, Col, Form, Input, Checkbox, Tabs, Divider } from 'antd';
import CrudButtons from "../../components/CrudButtons/CrudButtons";
import { useState, useLayoutEffect, useRef, useEffect } from 'react';
import { getRights } from "../../redux/actions/userRights.action";
import { useSelector, useDispatch } from 'react-redux';
import { ReadCookie, } from '../../utils/readCookie';
import Tables from "../../components/Table/Tables"
import { logColumns, freightTermColumns } from "../../utils/cols";
import { getLog } from "../../redux/actions/log.action"
import notification from '../../utils/notification'
import { loadFreightTerm, addFreightTerm, deleteFreightTerm, updateFreightTerm } from '../../redux/actions/freightTerm';
import { loadBergenBillingOption } from '../../redux/actions/bergenBillingOption';
import { TabTitle } from '../../utils/GeneralFunction';


const { TabPane } = Tabs;

const FreightTerm = ({ token }) => {
    TabTitle("Freight Term")
    const { BergenBillingOption, FreightTerm, userRights, log, } = useSelector(state => state)
    const [minimize, setMinimize] = useState(false);
    const [formState, setFormState] = useState('view');
    const [description, setDescription] = useState('');
    const [form] = Form.useForm();
    const freightTermInput = useRef(null);
    const [disable, setDisable] = useState(false);
    const [freightTermObj, setFreightTermObj] = useState(null);
    const [check, setCheck] = useState(true);
    const dispatch = useDispatch();
    const id = ReadCookie('menuId');


    useEffect(() => {
        dispatch(loadFreightTerm(token))
    }, [dispatch, token])


    useEffect(() => {
        dispatch(loadBergenBillingOption(token))
    }, [dispatch, token])


    const handleDelete = () => {
        if (freightTermObj) {
            dispatch(deleteFreightTerm(token, freightTermObj.freight_term_id)).then((res) => {
                if (res.type === "DELETE_FREIGHT_TERM_SUCCESS") {
                    notification("success", "Freight Deleted", "Record deleted successfully!");
                }
                if (res.type === "DELETE_FREIGHT_TERM_ERROR") {
                    notification("error", res?.payload?.request?.statusText, res?.payload?.data?.data);
                }
                form.setFieldsValue({
                    term: ""
                })
                // setCheck(false)
                setDescription("")
                setFreightTermObj(null)
                setFormState('view')
                dispatch(loadFreightTerm(token, id))

            })
        }
        setFormState("view")
    }

    useEffect(() => {

        if (freightTermObj) {
            setFormState('view')
            form.setFieldsValue({
                id: freightTermObj.freight_term_id,
                term: freightTermObj.freight_term_name,
                active: freightTermObj.is_active,

            });

            setDescription(freightTermObj.freight_term_name)
            setCheck(freightTermObj.is_active)


        }

    }, [freightTermObj]);

    useEffect(() => {
        if (description === '') {
            setDisable(true)
        } else {
            setDisable(false)
        }
    }, [description])




    useLayoutEffect(() => {
        dispatch(getRights(token, id)).then((res) => {
            if (res.type === "GET_USER_RIGHTS_SUCCESS") {
                if (!res?.payload.can_add) {
                    setFormState("table")
                }
            }
        });
    }, [])

    useEffect(() => {

        dispatch(getLog(token, { admin_freight_term: "admin_freight_term" }))
    }, [dispatch, token])


    const formSave = async () => {

        await form.validateFields().then((values) => {
            if (formState === "add") {
                dispatch(addFreightTerm(token, { freight_term_name: description, is_active: check }, id)).then((res) => {

                    if (res.type === "ADD_FREIGHT_TERM_ERROR") {
                        notification("error", "Not Created", res?.payload?.data?.data)
                    }
                    if (res.type === "ADD_FREIGHT_TERM_SUCCESS") {
                        notification("success", "Freight Created", "Freight Term created successfully!");
                        form.setFieldsValue({
                            term: ""
                        })
                        setFormState("view")
                        setDescription("")
                        setFreightTermObj(null)
                    }
                    dispatch(loadFreightTerm(token, id))
                })
            }
            if (formState === "edit") {
                dispatch(updateFreightTerm(token, { freight_term_name: description, is_active: check }, freightTermObj.freight_term_id)).then((res) => {
                    if (res.type === "UPDATE_FREIGHT_TERM_ERROR") {
                        notification("error", "Not Update", "Something went wrong")
                    }
                    if (res.type === "UPDATE_FREIGHT_TERM_SUCCESS") {
                        notification("success", "Freight Updated", "Record updated successfully")
                    }
                    dispatch(loadFreightTerm(token, id))
                })
            }

        }).catch((err) => {

        })
    }

    useEffect(() => {
        if (formState === "add") {
            freightTermInput.current.focus()
            form.setFieldsValue({
                id: null,
                term: null,
            })
            setCheck(true)
            setDescription("")
            setFreightTermObj(null)
        }
    }, [formState]);
    const filterReset = () => {
        setFormState("view")
        setFreightTermObj(null)
        setCheck(true)
        form.setFieldsValue({
            id: null,
            term: null,
        })
        setDescription(null)
    }


    return (
        <div className='styleContainer'>
            <div className='styleBody h-100' >
                <PageHeader title={"Freight Term"} minimize={setMinimize} check={minimize} />
                {
                    !minimize &&
                    <div className='bodyStyle' >
                        <div className='crudDiv' ><CrudButtons formType={formState} rights={userRights?.payload} formState={setFormState} disable={disable} reset={filterReset} save={formSave} onDelete={handleDelete} /></div>
                        <div className='styleContent' >
                            <Row className='tables-main-row-new' >
                                <Col xs={24} sm={24} md={10} lg={8} xl={6}>
                                    <div className='styleTable' >
                                        <Tables type="freightTerm" formState={formState} scrollX={"20rem"} freightTermObj={setFreightTermObj} source={FreightTerm?.payload?.data} col={freightTermColumns} paginate scroll={500} perPage={25} load={FreightTerm.loading} rowKey="ship_via_id" />
                                    </div>
                                </Col>
                                <Col xs={24} sm={24} md={14} lg={16} xl={18}>
                                    <div className='styleForm'  >
                                        <div className='testStyle' >
                                            <Form
                                                form={form}
                                                name="basic"
                                            // labelCol={{ span: 8 }}

                                            >
                                                <div className='customRow styleFormUpper ' >
                                                    {freightTermObj !== null && !(formState === "add") &&
                                                        <div className='customCols slc'>
                                                            <Form.Item
                                                                label="ID"
                                                                name="id"
                                                                initialValue={form.getFieldValue().id}
                                                                labelCol={{ span: 10 }}
                                                                wrapperCol={{ span: 14 }}

                                                            >
                                                                <Input size='small' className='styleInput id-field-style' readOnly />

                                                            </Form.Item>
                                                        </div>
                                                    }

                                                    <div className='customCols slc'>
                                                        <Form.Item
                                                            label="Term Name"
                                                            name="term"
                                                            initialValue={form.getFieldValue().desc}
                                                            labelCol={{ span: 10 }}
                                                            wrapperCol={{ span: 14 }}
                                                        >

                                                            <Input size='small' disabled={!(formState === "add" || formState === "edit")} ref={freightTermInput} onChange={(e) => setDescription(e.target.value)} className='styleInput' />
                                                        </Form.Item>
                                                    </div>
                                                    <div className='customCols slc'>
                                                        <Form.Item
                                                            label="Active"
                                                            name="active"
                                                            labelCol={{ span: 10 }}
                                                            wrapperCol={{ span: 14 }}
                                                        >
                                                            <Checkbox disabled={!(formState === "add" || formState === "edit")} checked={check} onChange={(e) => setCheck(e.target.checked)} />
                                                        </Form.Item>
                                                    </div>
                                                </div>
                                            </Form>
                                        </div>

                                        <div className='modalStyle' >


                                        </div>
                                        <Divider />
                                        <div className='styleTab' >
                                            <Tabs type='card' tabBarGutter={2} defaultActiveKey="1" centered  /**onChange={(key) => handleTab(key)} */ >
                                                <TabPane tab="Log Info" key="logs"  >
                                                    <div className='tabs' >
                                                        <Tables type="company" scrollX={"50rem"} scroll={800} perPage={10} source={log?.payload?.data} col={logColumns} load={log.loading} paginate />
                                                    </div>
                                                </TabPane>
                                            </Tabs>
                                        </div>
                                    </div>

                                </Col>
                            </Row>
                        </div>
                    </div>
                }
            </div>
        </div>





    )
}


export default FreightTerm